import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Layout,
  Avatar,
  Badge,
  Dropdown,
  Input,
  Space,
  Typography,
  Drawer,
  Button,
  theme,
} from "antd";
import {
  BellOutlined,
  SearchOutlined,
  UserOutlined,
  MenuOutlined,
  LogoutOutlined,
  SettingOutlined,
  AppstoreOutlined,
} from "@ant-design/icons";

const { Header } = Layout;
const { Text, Title } = Typography;

export default function Header1() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [userProfile, setUserProfile] = useState({
    name: "User",
    role: "Member",
    avatarUrl: null,
  });
  const { token } = theme.useToken();
  const navigate = useNavigate();

  // Fetch user info from localStorage
  useEffect(() => {
    const storedUserInfo = localStorage.getItem("userInfo");
    if (storedUserInfo) {
      try {
        const userData = JSON.parse(storedUserInfo);
        setUserProfile({
          name: userData.name || userData.companyName || "User",
          role: userData.role || userData.designation || "Member",
          avatarUrl: userData.avatarUrl || userData.logo || null,
        });
      } catch (error) {
        console.error("Error parsing user info:", error);
      }
    }
  }, []);

  // Handle logout
  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userInfo");
    navigate("/login");
  };

  // --- Styles matching your screenshot vibe ---
  const headerStyle = {
    background: "#ffffff",
    padding: "0 24px",
    boxShadow: "0 2px 8px #f0f1f2",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    height: "80px",
    zIndex: 1000,
    fontFamily: "'Rubik', sans-serif",
    flexShrink: 0,
  };

  const primaryColor = "#3C007A"; // Primary purple
  const accentColor = "#FF8F00"; // Accent orange

  // --- Dropdown Menu Items ---
  const userMenuItems = [
    {
      key: "1",
      label: (
        <Space direction="vertical" size={0} style={{ padding: "4px 0" }}>
          <Text strong>{userProfile.name}</Text>
          <Text type="secondary" style={{ fontSize: "12px" }}>
            {userProfile.role}
          </Text>
        </Space>
      ),
    },

    { type: "divider" },
    // {
    //   key: "2",
    //   icon: <UserOutlined />,
    //   label: <Link to="/dashboard/company_profile">My Profile</Link>,
    // },
    // {
    //   key: "3",
    //   icon: <SettingOutlined />,
    //   label: <Link to="/dashboard/company_homepage">Dashboard</Link>,
    // },
    { type: "divider" },
    {
      key: "4",
      icon: <LogoutOutlined />,
      label: "Logout",
      onClick: handleLogout,
      style: { backgroundColor: "#FF8F00", color: "#fff" },
    },
  ];

  return (
    <>
      <Header style={headerStyle}>
        {/* LEFT: Logo & Welcome Message */}
        <div style={{ display: "flex", alignItems: "center", gap: "24px" }}>
          {/* Logo */}
          <Link
            to="/"
            className="site-logo"
            style={{ display: "flex", alignItems: "center" }}
          >
            <img
              alt="AID Logo"
              src="/img/aid.svg"
              style={{ height: "75px", width: "auto" }}
            />
          </Link>

          {/* Desktop Welcome Message */}
          <div
            style={{
              borderLeft: "1px solid #f0f0f0",
              paddingLeft: "24px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <Title
              level={3}
              style={{
                margin: 0,
                fontFamily: "Rubik, sans-serif",
                fontWeight: 500,
                fontSize: "24px",
                lineHeight: "1.2",
                marginBottom: "0",
              }}
            >
              <span style={{ color: primaryColor }}>Welcome, </span>
              <span style={{ color: accentColor }}>
                {userProfile.name.split(" ")[0]}!
              </span>
            </Title>
            {/* <Text
              type="secondary"
              style={{
                fontSize: "12px",
                fontFamily: "Rubik, sans-serif",
                lineHeight: "1.4",
                marginTop: "3px",
              }}
            >
              Vidarbha Steel Industries
            </Text> */}
          </div>
        </div>

        {/* RIGHT: Actions & Profile */}
        <div style={{ display: "flex", alignItems: "center" }}>
          {/* Desktop Actions */}
          <Space size="large" className="d-none d-md-flex">
            {/* Search Bar */}
            <Input
              placeholder="Search..."
              prefix={<SearchOutlined style={{ color: "#bfbfbf" }} />}
              bordered={false}
              style={{
                background: "#f5f5f5",
                borderRadius: "8px",
                width: "200px",
              }}
            />

            {/* Notifications */}
            {/* <Badge count={3} color={accentColor} size="small">
              <Button type="text" shape="circle" icon={<BellOutlined style={{ fontSize: '18px' }} />} />
            </Badge> */}

            {/* Profile Dropdown */}
            <Dropdown
              menu={{ items: userMenuItems }}
              placement="bottomRight"
              arrow
            >
              <Space
                style={{
                  cursor: "pointer",
                  padding: "4px 8px",
                  borderRadius: "8px",
                  transition: "0.3s",
                }}
              >
                <Avatar
                  size="large"
                  style={{
                    backgroundColor: primaryColor,
                    verticalAlign: "middle",
                  }}
                  icon={<UserOutlined />}
                  src={userProfile.avatarUrl}
                >
                  {userProfile.name.charAt(0)}
                </Avatar>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    lineHeight: 1.2,
                  }}
                >
                  <Text
                    strong
                    style={{
                      fontSize: "16px",
                      fontFamily: "Rubik, sans-serif",
                      fontWeight: 400,
                    }}
                  >
                    {userProfile.name}
                  </Text>
                  <Text
                    type="secondary"
                    style={{
                      fontSize: "11px",
                      fontFamily: "Rubik, sans-serif",
                    }}
                  >
                    {userProfile.role}
                  </Text>
                </div>
              </Space>
            </Dropdown>
          </Space>

          {/* Mobile Menu Trigger */}
          <Button
            className="d-md-none"
            type="text"
            icon={<MenuOutlined style={{ fontSize: "20px" }} />}
            onClick={() => setMobileMenuOpen(true)}
          />
        </div>
      </Header>

      {/* Mobile Drawer (Responsive Menu) */}
      <Drawer
        title="Menu"
        placement="right"
        onClose={() => setMobileMenuOpen(false)}
        open={mobileMenuOpen}
        styles={{ body: { padding: 0 } }}
      >
        <div
          style={{
            padding: "20px",
            background: "#f9f9f9",
            textAlign: "center",
          }}
        >
          <Avatar
            size={64}
            style={{ backgroundColor: primaryColor, marginBottom: "10px" }}
          >
            {userProfile.name.charAt(0)}
          </Avatar>
          <Title
            level={5}
            style={{ margin: 0, fontFamily: "Rubik, sans-serif" }}
          >
            {userProfile.name}
          </Title>
          <Text type="secondary" style={{ fontFamily: "Rubik, sans-serif" }}>
            {userProfile.role}
          </Text>
        </div>

        <div style={{ padding: "20px" }}>
          <Space direction="vertical" style={{ width: "100%" }} size="large">
            <Link
              to="/dashboard/company_homepage"
              onClick={() => setMobileMenuOpen(false)}
            >
              <Space>
                <AppstoreOutlined /> Dashboard
              </Space>
            </Link>
            <Link
              to="/dashboard/company_profile"
              onClick={() => setMobileMenuOpen(false)}
            >
              <Space>
                <UserOutlined /> Profile
              </Space>
            </Link>
            <Link to="/notifications" onClick={() => setMobileMenuOpen(false)}>
              <Space>
                <BellOutlined /> Notifications{" "}
                <Badge count={3} size="small" color={accentColor} />
              </Space>
            </Link>
            <Button
              block
              icon={<LogoutOutlined />}
              onClick={handleLogout}
              style={{
                backgroundColor: "#FF8F00",
                borderColor: "#FF8F00",
                color: "#fff",
              }}
            >
              Logout
            </Button>
          </Space>
        </div>
      </Drawer>
    </>
  );
}